var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('pre',{staticStyle:{"font-size":"8px"}},[_vm._v(_vm._s(_vm.valueString))])])
}
var staticRenderFns = []

export { render, staticRenderFns }